import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../base.component';

@Component({
  selector: 'app-page-info',
  templateUrl: './page-info.component.html',
  styleUrls: ['./page-info.component.scss'],
})
export class PageInfoComponent implements OnInit {
  @Input() bodyClass = '';
  @Input() pageCategory = 'Home';
  @Input() categoryURL = '/';
  @Input() pageTitle: string;
  @Input() pageURL = 'https://www.farmersmarketla.com/';
  @Input() pageImage = 'https://www.farmersmarketla.com/assets/images/fb-og-image.jpg';
  @Input() pageDescription = 'A favorite destination among locals and tourists since 1934, LA\'s world famous Original Farmers Market offers over 100 gourmet grocers, restaurants from across the globe, and world class shopping in an open-air setting. ';
  @Input() pageKeywords = 'Farmers Market Los Angeles, The Original Farmers Market, 3rd and Fairfax, Gourmet Groceries, Best Grocery Store, Top Tourist Destination, Best Tourist Attraction, Best Farmers Market LA, Best Shopping, Best Dining, Meet Me at Third and Fairfax, historic Farmers Market, Farmers Market Clock Tower, Old Farmers Market in LA, Farmers Market next to the Grove.';
  @Input() showHeader = true;
  @Input() showFooter = true;

  constructor(public baseComponent: BaseComponent) { }

  ngOnInit() {
  //console.log('PageInfoComponent(): updating page info');
    this.baseComponent.updatePageInfo({
      bodyClass: this.bodyClass,
      pageCategory: this.pageCategory,
      categoryURL: this.categoryURL,
      pageTitle: this.pageTitle,
      pageURL: this.pageURL,
      pageImage: this.pageImage,
      pageDescription: this.pageDescription,
      pageKeywords: this.pageKeywords,
      showHeader: this.showHeader,
      showFooter: this.showFooter
    });
  }

}
